import { render, staticRenderFns } from "./EditRuleDetails.vue?vue&type=template&id=9b293c90"
import script from "./EditRuleDetails.vue?vue&type=script&lang=js"
export * from "./EditRuleDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports